import { EFiltersActions } from '../../../constants/actionTypes/filters';
import { TReduxActions } from '../../../types/redux';
import { IFiltersState } from '../../../types/redux/filters';

export function agenciesFiltersReducer(state: IFiltersState = {}, action: TReduxActions) {
  switch (action.type) {
    case EFiltersActions.SET_DEAL_TYPE_AGENCIES:
      return {
        ...state,
        dealType: action.payload,
      };

    case EFiltersActions.SET_OFFER_TYPE_AGENCIES:
      return {
        ...state,
        offerType: action.payload,
      };

    case EFiltersActions.SET_SORT_BY_AGENCIES:
      return {
        ...state,
        sortBy: action.payload,
      };

    case EFiltersActions.SET_SEARCH_TEXT_AGENCIES:
      return {
        ...state,
        searchText: action.payload,
      };

    default:
      return state;
  }
}
